import styled, { css } from 'styled-components';
import Box from '@nubank/nuds-web/components/Box/Box';
import { breakpointsMedia } from '@nubank/nuds-web/styles/breakpoints';
import { spacing } from '@nubank/nuds-web/styles/themeUtils';

import addWebpBackgroundImage from 'styles/addWebpBackgroundImage';

export const StyledBox = styled(Box)`
  ${breakpointsMedia({
    xs: addWebpBackgroundImage('boy-looking-to-the-front/boy-looking-to-the-front@0.5x.jpg'),
    md: addWebpBackgroundImage('boy-looking-to-the-front/boy-looking-to-the-front@0.75x.jpg'),
    lg: addWebpBackgroundImage('boy-looking-to-the-front/boy-looking-to-the-front@1x.jpg'),
  })}
  background-size: cover;
  ${breakpointsMedia({
    xs: css`
      padding: ${spacing('12x', '4x')};
      min-height: 100vh;
    `,
    sm: css`
      min-height: 80vh;
    `,
    md: css`
      padding: ${spacing('20x', '8x')};
      min-height: 90vh;
    `,
    lg: css`
      padding: ${spacing('32x', '12x')};
    `,
  })}
`;

StyledBox.displayName = 'StyledBox';
